module.exports = __webpack_public_path__ + "static/tod-logo-966830e568096ba0b196d568905df356.svg";